import { TabList } from "@mui/lab";
import { Tab, styled } from "@mui/material";
import { alpha } from "@mui/material/styles";

export const RootTabStyle = styled(TabList)(({ theme, length }) => ({
    width: '100%',
    maxWidth: '100%',
    borderRadius: theme.shape.borderRadius * 2,
    background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.grey[50]} 100%)`,
    padding: theme.spacing(0.75),
    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.05)}`,
    border: `1px solid ${alpha(theme.palette.primary.light, 0.2)}`,
    overflow: 'hidden',
    boxSizing: 'border-box',
    position: 'relative',
    '& .MuiTabs-flexContainer': {
      justifyContent: 'space-between',
      width: '100%',
      maxWidth: '100%',
      overflow: 'hidden',
      flexWrap: 'wrap',
      gap: theme.spacing(0.5),
    },
    '& .MuiTab-root': {
      flex: '1 1 auto',
      minWidth: '120px',
      maxWidth: '200px',
      minHeight: 48,
      borderRadius: theme.shape.borderRadius * 1.5,
      margin: theme.spacing(0.25),
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      overflow: 'hidden',
      boxSizing: 'border-box',
      whiteSpace: 'normal',
      textOverflow: 'unset',
      wordWrap: 'break-word',
      wordBreak: 'break-word',
      hyphens: 'auto',
      lineHeight: 1.2,
      padding: theme.spacing(1, 0.5),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      '& .MuiTab-wrapper': {
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        wordBreak: 'break-word',
        lineHeight: 1.2,
        textAlign: 'center',
        width: '100%',
      },
    },
    // Responsive behavior
    '@media (max-width: 768px)': {
      '& .MuiTabs-flexContainer': {
        flexDirection: 'column',
        gap: theme.spacing(0.25),
      },
      '& .MuiTab-root': {
        width: '100%',
        maxWidth: '100%',
        minWidth: 'unset',
      },
    },
    '@media (max-width: 1200px)': {
      '& .MuiTab-root': {
        minWidth: '100px',
        maxWidth: '150px',
        fontSize: '0.8rem',
      },
    },
  }));
  
  export const RootTabItemStyles = styled(Tab)(({ theme }) => ({
    color: theme.palette.text.secondary,
    backgroundColor: 'transparent',
    borderRadius: theme.shape.borderRadius * 1.5,
    fontWeight: 700,
    fontSize: '0.875rem',
    letterSpacing: '0.5px',
    textTransform: 'none',
    minHeight: 48,
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    position: 'relative',
    overflow: 'hidden',
    boxSizing: 'border-box',
    whiteSpace: 'normal',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    hyphens: 'auto',
    lineHeight: 1.2,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiTab-wrapper': {
      whiteSpace: 'normal',
      wordWrap: 'break-word',
      wordBreak: 'break-word',
      lineHeight: 1.2,
      textAlign: 'center',
    },
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
      transition: 'left 0.5s ease-in-out',
    },
    '&:hover': {
      backgroundColor: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${alpha(theme.palette.primary.light, 0.05)} 100%)`,
      color: theme.palette.primary.main,
      transform: 'translateY(-1px)',
      boxShadow: `0 4px 12px ${alpha(theme.palette.primary.main, 0.2)}`,
      '&:before': {
        left: '100%',
      },
    },
    '&.Mui-selected': {
      color: 'white',
      background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
      boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.4)}, 0 0 0 1px ${alpha(theme.palette.primary.main, 0.2)}`,
      transform: 'translateY(-2px)',
      '&:hover': {
        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
        boxShadow: `0 6px 20px ${alpha(theme.palette.primary.main, 0.5)}, 0 0 0 1px ${alpha(theme.palette.primary.main, 0.3)}`,
        transform: 'translateY(-3px)',
      },
      '&:before': {
        background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
      },
    },
    '&:active': {
      transform: 'translateY(0)',
    },
  }));
  